import React, { useEffect, useState } from "react";
import { format } from "date-fns";
import user from "../../assets/user.gif";
import DaterangePicker from "../../common/Daterangepicker";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { getHubName } from "../../api/api";
import commonapihandler from "../../common/commonapihandler";
import {
  Tabs,
  Tab,
  Card,
  CardContent,
  CardActions,
  Button,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from "@mui/material";

export default function Bookingdashboard() {
  const profile = JSON.parse(localStorage.getItem("profile"));
  const [selectedProject, setSelectedProject] = useState(
    "ACME Corp. Backend App"
  );
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const today = new Date();
  today.setHours(23, 59, 59, 999);
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(today.getMonth() - 1);
  const [selectionRange, setSelectionRange] = useState({
    startDate: oneMonthAgo,
    endDate: today,
    key: "selection",
  });
  const [cities, setCities] = useState(null);
  const [city, setCity] = useState("");
  const [hubs, setHubs] = useState(null);
  const [hub, setHub] = useState("");
  const [stats, setStats] = useState(null);
  const [confirmedBooingList, setConfirmedBookingList] = useState([]);

  // Pagination state
  const [page, setPage] = useState(0);
  const rowsPerPage = 10;

  const getCityNames = async () => {
    try {
      const response = await fetch(`${apiUrl}/api/cities/indexify`);
      const data = await response.json();
      if (data) setCities(data);
    } catch (error) {
      console.error("Error fetching City Names:", error);
    }
  };

  const getAllHubListData = async () => {
    try {
      const response = await fetch(`${apiUrl}/api/hubs?limit=1000`);
      const data = await response.json();
      if (data) setHubs(data?.entities?.rows);
    } catch (error) {
      console.error("Error fetching City Names:", error);
    }
  };

  const getHubNames = async (value) => {
    const apiDetails = await getHubName(value);
    const data = await commonapihandler(apiDetails?.apiUrl, apiDetails?.method);
    setHubs(data?.entities?.rows || []);
  };

  const handleCityChange = (event) => {
    const value = event.target.value;
    setCity(value);
    // getHubNames(value);
  };

  const handleHubChange = (event) => {
    setHub(event.target.value);
  };

  useEffect(() => {
    getCityNames();
    getAllHubListData();
  }, []);

  function formatDateForApi(date, type) {
    const pad = (n) => (n < 10 ? "0" + n : n);
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    // Force startDate to 00:00 and endDate to 23:59
    let hours = type === "start" ? "00" : "23";
    let minutes = type === "start" ? "00" : "59";

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  const formattedStartDate = formatDateForApi(
    selectionRange?.startDate,
    "start"
  );
  const formattedEndDate = formatDateForApi(selectionRange?.endDate, "end");

  const bookingDashboards = async () => {
    let query = `startDate=${formattedStartDate}&endDate=${formattedEndDate}`;

    if (city) {
      query += `&cityId=${city}`;
    }

    if (hub) {
      query += `&hubId=${hub}`;
    }

    try {
      const response = await fetch(
        `${apiUrl}/api/bookings/bookingdashboard?${query}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setStats(data?.dataValues);
        setConfirmedBookingList(data?.dataValues?.bookingConfirmedList || []);
        setPage(0); // reset to first page when new data loads
      } else {
        console.error("Unexpected API response:", data);
      }
    } catch (error) {
      console.error("Error fetching fuel report:", error);
    }
  };

  useEffect(() => {
    bookingDashboards();
  }, []);

  // Pagination slice
  const paginatedData = confirmedBooingList.slice(
    page * rowsPerPage,
    (page + 1) * rowsPerPage
  );

  return (
    <div>
      {/* --- HEADER --- */}
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-6">
        <div className="flex items-center gap-4 mt-6">
          <img className="w-20 h-20 rounded-full" src={user} alt="User" />
          <h1 className="text-2xl font-bold">Welcome back, {profile?.name}!</h1>
        </div>
      </div>

      {/* --- FILTERS --- */}
      <div className="md:flex gap-4 mx-8">
        <h1 className="mt-2 text-xl">Filter By :</h1>
        <div className="min-w-[200px]">
          <DaterangePicker
            selectionRange={selectionRange}
            setSelectionRange={setSelectionRange}
            style={() => {}}
          />
        </div>
        <div className="min-w-[180px]">
          <FormControl fullWidth size="small">
            <InputLabel id="city-select-label">City</InputLabel>
            <Select
              labelId="city-select-label"
              id="city-select"
              value={city}
              label="City"
              onChange={handleCityChange}
            >
              {cities &&
                Object.entries(cities).map(([key, value]) => (
                  <MenuItem key={key} value={key}>
                    {value}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </div>
        <div className="min-w-[180px]">
          <FormControl fullWidth size="small">
            <InputLabel id="hub-select-label">Hub</InputLabel>
            <Select
              labelId="hub-select-label"
              id="hub-select"
              value={hub}
              label="Hub"
              onChange={handleHubChange}
            >
              {hubs?.length ? (
                hubs.map((item, index) => (
                  <MenuItem key={index} value={item?.id}>
                    {item?.hubName}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value="">
                  <em>Select City First</em>
                </MenuItem>
              )}
            </Select>
          </FormControl>
        </div>
        <div className="flex gap-2 justify-end">
          <button
            className="bg-blue-600 text-white px-6 py-2 rounded-full shadow-md hover:bg-blue-700 transition"
            onClick={bookingDashboards}
          >
            Search
          </button>
          <button
            onClick={() => {
              bookingDashboards();
              setCity("");
              setHub("");
              setSelectionRange({
                startDate: oneMonthAgo,
                endDate: today,
                key: "selection",
              });
              setPage(0);
            }}
            className="bg-red-400 text-white px-6 py-2 rounded-full shadow-md hover:bg-gray-500 transition"
          >
            Reset
          </button>
        </div>
      </div>

      {/* --- DASHBOARD CARDS --- */}
      <div className="flex-auto border-t -mt-px pt-6">
        <div className="max-w-screen-xl mx-auto px-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
            <Card1
              title="Fleet Size"
              value={stats?.totalVehicleCount}
              color="text-blue-500"
              sub="Total Vehicles"
            />
            <Card1
              title="Blocked Vehicles"
              value={stats?.blockedVehicleCount}
              color="text-red-500"
              sub="Total Blocked"
            />
            <Card1
              title="Availability"
              value={stats?.availableVehicle}
              color="text-amber-500"
              sub="Vehicle Available"
            />
            <Card1
              title="Inquiry"
              value={stats?.totalInquiry}
              color="text-amber-500"
              sub="Booking Inquiry"
            />
            <Card1
              title="Document"
              value={stats?.documentPending}
              color="text-amber-500"
              sub="Document Pending"
            />
            <Card1
              title="Payment"
              value={stats?.paymentPending}
              color="text-red-500"
              sub="Payment Pending"
            />
            <Card1
              title="Confirmed"
              value={stats?.bookingConfirmed}
              color="text-green-500"
              sub="Booking Confirmed"
            />
            <Card1
              title="Revenue Bookings"
              value={stats?.bookingClosed}
              color="text-blue-500"
              sub="Booking Closed"
            />
            <Card1
              title="Revenue Lost"
              value={stats?.inquiryClosed}
              color="text-amber-500"
              sub="Inquiry Closed"
            />
            <Card1
              title="Cancellation"
              value={stats?.bookingCancelled}
              color="text-amber-500"
              sub="Booking Cancelled"
            />
          </div>
        </div>
      </div>

      {/* --- BOOKING TABLE --- */}
      <div className="p-6 bg-white shadow rounded-2xl overflow-hidden mt-6">
        <h3 className="mb-4 font-semibold text-lg">Booking Confirmed List</h3>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Id</TableCell>
              <TableCell>Booking Code</TableCell>
              <TableCell>Vehicle</TableCell>
              <TableCell>Vehicle Registration No</TableCell>
              <TableCell>Cost to Customer</TableCell>
              <TableCell>City</TableCell>
              <TableCell>Hub</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedData.map((row, i) => (
              <TableRow key={i} hover>
                <TableCell>{row.id}</TableCell>
                <TableCell>{row?.booking_code || "-"}</TableCell>
                <TableCell>{row.vehicle_name || "-"}</TableCell>
                <TableCell>{row.vehicle_registration_no || "-"}</TableCell>
                <TableCell>{"₹ " + row.cost_to_customer || "-"}</TableCell>
                <TableCell>{cities[row.city_id] || "-"}</TableCell>
                <TableCell>
                  {hubs.find((hub) => hub?.id === row.city_id)?.hubName || "-"}
                </TableCell>
              </TableRow>
            ))}
            {paginatedData.length === 0 && (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  No Data Found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>

        {/* Pagination Controls */}
        <div className="flex justify-between items-center mt-4">
          <button
            disabled={page === 0}
            onClick={() => setPage((prev) => prev - 1)}
            className={`px-4 py-2 rounded ${
              page === 0
                ? "bg-gray-300 text-gray-600 cursor-not-allowed"
                : "bg-blue-600 text-white hover:bg-blue-700"
            }`}
          >
            Previous
          </button>
          <span>
            Page {page + 1} of{" "}
            {Math.ceil(confirmedBooingList.length / rowsPerPage) || 1}
          </span>
          <button
            disabled={(page + 1) * rowsPerPage >= confirmedBooingList.length}
            onClick={() => setPage((prev) => prev + 1)}
            className={`px-4 py-2 rounded ${
              (page + 1) * rowsPerPage >= confirmedBooingList.length
                ? "bg-gray-300 text-gray-600 cursor-not-allowed"
                : "bg-blue-600 text-white hover:bg-blue-700"
            }`}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
}

// Reusable card component
function Card1({ title, value, color, sub }) {
  return (
    <div className="flex flex-col p-6 bg-white shadow-lg rounded-2xl">
      <div className="flex flex-col items-center mt-2">
        <div className={`text-5xl font-bold ${color}`}>{value}</div>
        <div className="text-lg font-medium text-gray-600">{sub}</div>
      </div>
    </div>
  );
}
